import { Button, Spinner } from 'react-bootstrap';
import React, { useContext, useEffect, useState } from 'react';
import { contentfulPropTypes, onboardingPropTypes } from '../../propTypes';
import { flowSteps, recordFlowProgress } from '../../utils/recordFlowProgress';

import { ConsentContext } from '../../context/ConsentContext';
import PaymentCard from '../../ui/Icon/PaymentCard';
import ReactMarkdown from 'react-markdown';
import SmartMeter from '../../ui/Icon/SmartMeter';
import { SpacerHr } from '../../ui/Styled';
import { VerifyMethodBlock } from '../../ui';
import { getValidationMethods } from '../../api/SmartMeter';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledParagraph = styled.p`
  @media (max-width: 575px) {
    margin-bottom: 25px;
  }
`;

const StyledBlockWrapper = styled.div`
  border: 1px solid #afb6b9;
  border-radius: 4px;
  position: relative;
  padding: 25px 25px;
`;

const StyledIconWrapper = styled.div`
  position: absolute;

  @media (max-width: 575px) {
    position: relative;
    padding-bottom: 15px;
  }
`;

const StyledReactMarkdown = styled(ReactMarkdown)`
  text-align: left;
  margin-left: 90px;

  p {
    margin-bottom: 5px;
  }

  @media (max-width: 575px) {
    text-align: center;
    margin-left: 0;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 15px;
  margin-bottom: 0;
`;

const VerifyContainer = ({ contentful, loading, fetched }) => {
  const { consentFlow, mpan, verificationMethods, setVerificationMethods } =
    useContext(ConsentContext);
  const navigate = useNavigate();
  const [loadingMethods, setLoadingMethods] = useState(true);
  useEffect(() => {
    const asyncRecordFlowProgress = async () => {
      let res;
      try {
        res = await getValidationMethods(mpan);
      } catch (e) {
        console.log(e);
      }
      setLoadingMethods(false);
      if (!res?.status) {
        setVerificationMethods(res);
        if (res?.ihd?.available) {
          await recordFlowProgress(flowSteps.PAYMENT_CARD_OR_IHD);
        } else {
          await recordFlowProgress(flowSteps.PAYMENT_CARD_OR_IHD_CANT_FIND_IHD);
        }
      } else {
        console.log(await res.text());
        setVerificationMethods(false);
      }
    };
    asyncRecordFlowProgress();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    !loading &&
    fetched && (
      <>
        <p>
          Step <strong>3</strong> of <strong>3</strong>
        </p>
        <h1 className="mb-3">{contentful?.title}</h1>
        <StyledParagraph>{contentful?.subtitle}</StyledParagraph>
        <VerifyMethodBlock
          featureLabel={contentful?.utilityText}
          icon={PaymentCard}
          markdown={contentful?.body}
          onClick={() => navigate(`/${consentFlow}/card-details`)}
          buttonLabel={contentful?.primaryButtonText}
        />
        <SpacerHr label="or" className="w-100" />
        <StyledBlockWrapper className="mt-1">
          <div className="d-relative">
            <StyledIconWrapper>
              <SmartMeter />
            </StyledIconWrapper>
          </div>
          {loadingMethods ? (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          ) : (
            <>
              {verificationMethods?.ihd?.available ? (
                <>
                  <StyledReactMarkdown>
                    {contentful?.bodyEnd}
                  </StyledReactMarkdown>
                  <StyledButton
                    variant="secondary"
                    onClick={() => navigate(`/${consentFlow}/meter-code`)}
                    className="w-100">
                    {contentful?.secondaryButtonText}
                  </StyledButton>
                </>
              ) : (
                <StyledReactMarkdown>
                  {`${contentful?.bodyEndExtra.replace(
                    '{consent_flow}',
                    consentFlow,
                  )}`}
                </StyledReactMarkdown>
              )}
            </>
          )}
        </StyledBlockWrapper>
      </>
    )
  );
};

VerifyContainer.propTypes = {
  ...contentfulPropTypes,
  ...onboardingPropTypes,
};

export default withContentfulTag(
  VerifyContainer,
  'web_app_onboarding_verify_address_page',
);
